import React from "react";

import { useCloudFileApi } from "../../../../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { convertTimestringToTimestamp } from "../../../../../../../../../common/utils/convertTimestringToTimestamp";
import { useVideoRekognitionResultContext } from "../../hooks/useVideoRekognitionResultContext";
import { OverwriteSegmentFormInputs } from "./OverwriteSegmentForm";

export const useOverwriteSegmentForm = () => {
    const { overwriteRekognitionSegment } = useCloudFileApi();
    const { cloudFileId, updateItem } = useVideoRekognitionResultContext();

    const updateRekognitionSegment = async (
        segmentId: string,
        { startTimestamp, endTimestamp }: OverwriteSegmentFormInputs
    ) => {
        const formattedStartTimestamp = convertTimestringToTimestamp(startTimestamp);
        const formattedEndTimestamp = convertTimestringToTimestamp(endTimestamp);

        await overwriteRekognitionSegment({
            cloudFileId,
            segmentId,
            startTimestamp: formattedStartTimestamp,
            endTimestamp: formattedEndTimestamp
        });

        updateItem(segmentId, formattedStartTimestamp, formattedEndTimestamp);
    };

    return {
        updateRekognitionSegment
    };
};
